export const OAUTH_POST_MESSAGE_TYPE = 'rudderstack_oauth';
export const OAUTH_CHANNEL_NAME = 'oauth_channel';
